import * as React from 'react';
import styled from 'styled-components';

export const RecipientDetailsWrapper = styled.table`
    width: 100%;

    tr {
        height: 30px;
    }

    .rd-label {
        font-weight: 600;
        text-align: right;
        padding-right: 10px;
        // width: 100px;
    }

    .rd-value {
        // text-align: right;
        width: 50px;
    }
`;

export const DirectedDonorsWrapper = styled.div`
    display: flex;
    margin-bottom: 20px;

    border: 1px solid #eee;
    border-radius: 4px;

    .dd-header {
        color: orange;
        font-weight: bold;
        padding-top: 3px;
        text-align: center;
        height: 25px;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
    }

    .dd-label {
        text-align: right;
        font-weight: 600;
        padding-right: 10px;
        height: 25px;
        padding-top: 3px;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
    }

    .dd-value {
        text-align: center;
        height: 25px;
        padding-top: 3px;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
    }

    .dd-antibodies, .dd-age, .dd-height, .dd-days, .dd-post-pref-matches, .dd-chips, .dd-post-pref-power, .dd-cpra {
        background-color: #eee;
        border-bottom: 1px solid #fff;
        border-right: 1px solid #fff;
    }
`;

export const styles: { [key: string]: React.CSSProperties } = {
    chartWrapper: {
        width: '100%',
        overflow: 'auto',
        border: '1px solid #ddd',
        borderRadius: 4,
        padding: 5,
        marginBottom: 20
    },
    chartLoading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 400
    },
};